import { render, staticRenderFns } from "./Simulatoradvanced.vue?vue&type=template&id=2b0b2627&"
import script from "./Simulatoradvanced.vue?vue&type=script&lang=js&"
export * from "./Simulatoradvanced.vue?vue&type=script&lang=js&"
import style0 from "./Simulatoradvanced.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports